
// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

export default class CryptoWithdrawalsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'crypto-withdrawals';
        this.Server = this.props.context.getState().server.cryptoWithdrawals;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['uuid', 'hash'];

        const defaultHead = [
            {
                id: 'uuid',
                label: 'uuid',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'accountId',
                label: 'account',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'walletAccounts',
                object: 'account',
                show: 'accountNumber'
            },
            {
                id: 'cryptoAmount',
                label: 'cryptoAmount',
                alignRight: true,
                cell: 'CryptoAmount',
                displayGrid: true
            },
            {
                id: 'accountAmount',
                label: 'accountAmount',
                alignRight: true,
                cell: 'Amount',
                displayGrid: true
            },
            {
                id: 'sendeeWalletAddress',
                label: 'sendeeWalletAddress',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'hash',
                label: 'hash',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}

